<template>
	<div class="comwidth" v-if="moduleOneData && moduleTwoData">
		<div class="index">
			<div class="header">
				<span>{{ moduleOneData.title }}</span>
			</div>
			<div class="numbershow">
				<!-- <div > -->
					<div class="item" v-for="(item, index) in moduleOneData.one_values" :key='index'>
						<span class="title">{{ item.item }}</span>
						<span class="num rzqydh">
							<font class="szdh_1" id="szdh_a">{{ item.count }}</font>
						</span>
					</div>
			</div>
			
			<div class="rl">
				<div class="left" id="goindex3">
					<div class="title">{{ moduleTwoData.one_child_map.title }}</div>
					<div class="park">
						<div class="parkname">{{ moduleTwoData.one_child_map.park_name }}</div>
						<div class="parkdata">
							<div v-for="(item, index) in moduleTwoData.one_child_map.values" :key='index'>
								{{ item.item }}：<span class="ruzhuNum">{{ item.count }}</span><br>
							</div>
						</div>
					</div>
					<div class="paiming">
						<div class="paimingtitle">{{ moduleTwoData.two_child_map.title }}</div>
						<div class="paiminglist">
							<ul id="numberShowID">
								<li class="item" v-for="(item, index) in moduleTwoData.two_child_map.values" :key='index'>
									<span :class="'img img' + (parseInt(index + 1) > 3 ? 0 : parseInt(index + 1))">{{ parseInt(index + 1) > 3 ? parseInt(index + 1) : '' }}</span>
									<span class="company">{{ item.item }}</span>
									<span class="number">{{ item.count }}</span>
								</li>
							</ul>
						</div>
					</div>
					<div class="quweitu">
						<div class="dian dian1 over" ></div>
						<div class="dian dian2" ></div>
						<div class="dian dian3"></div>
						<div class="dian dian4"></div>
						<div class="dian dian5"></div>
						<div class="dian dian6"></div>
						<div class="dian dian7"></div>
						<div class="dian dian8"></div>
						<div class="dian dian9"></div>
						<div class="dian dian10"></div>
						<div class="dian dian11"></div>
						<div class="dian dian12"></div>
					</div>
				</div>
				<div class="right" ref="asd" >
					<div class="box">
						<div class="item">
							<div class="title">{{ moduleThreeData.one_child_map.chart_name }}</div>
							<!-- <div ref="myChart" :style="{width: '300px', height: '300px'}"></div> -->
							<div ref="tubiao1" style="width:383px;height:336px;"></div>
						</div>
						<div class="item">
							<div class="title">{{ moduleThreeData.two_child_map.chart_name }}</div>
							<div ref="tubiao2" style="width:383px;height:336px;"></div>
						</div>
						<div class="item">
							<div class="title">{{ moduleThreeData.three_child_map.chart_name }}</div>
							<div ref="tubiao3" style="width:383px;height:336px;"></div>
						</div>
						<div class="item">
							<div class="title"><a href="index1.html" class="defaulta">{{ moduleThreeData.four_child_map.chart_name }}</a></div>
							<div ref="tubiao4" style="width:383px;height:336px;"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				moduleOneData: '',
				moduleTwoData: '',
				moduleThreeData: '',
				timer: null
			}
		},
		mounted() {
			this.getOne()
			this.getTwo()
			this.getThree()
			this.timer = setInterval(() => {
				this.getOne()
				this.getTwo()
				this.getThree()
			}, 30000)
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer)
			}
		},
		methods: {
			async getOne() {
				const res = await API.jk1()
				this.moduleOneData = res.body
			},
			async getTwo() {
				const res = await API.jk2()
				this.moduleTwoData = res.body
			},
			async getThree() {
				const res = await API.jk3()
				this.moduleThreeData = res.body
				this.drawLine()
				this.drawLineTwo()
				this.drawLineThree()
				this.drawLineFour()
			},
			drawLine(){
				setTimeout(() => {
					const dv = this.$refs.tubiao1
					let myChart = this.$echarts.init(dv)
					const dataname = []
					const data = []
					this.moduleThreeData.one_child_map.business_values.forEach(item => {
						dataname.push(item.item)
						data.push({
							value: item.count,
							name: item.item
						})
					})
					// 绘制图表
					myChart.setOption({
						legend: {
							orient: 'horizontal',
							bottom: '15%',
							// data: ['科学研究和技术服务业', '制造业', '批发和零售业', '信息传输、软件和信息技术服务', '金融业', '租赁和商务服务业', '其他'],
							data: dataname,
							textStyle: {
								color: "#fff"
							},
							itemWidth: 13,
							itemHeight: 13,
							icon: 'circle'
						},
						series: [{
							type: 'pie',
							selectedMode: 'single',
							radius: 97, //图的大小
							center: ['50%', '35%'], //图的位置，距离左跟上的位置
							color: ['#FFE900', '#1B57E3', '#EE584F', '#4CAFF5', '#B843EF', '#0EE19E', '#F59B30'],
							label: {
								normal: {
									position: 'inner',
									formatter: '{c}',
									textStyle: {
										color: '#fff',
										fontWeight: 'bold',
										fontSize: 14
									}
								}
							},
							labelLine: {
								normal: {
									show: true
								}
							},
							data: data
						}],
						})
				}, 500)
				
			},
			drawLineTwo() {
				setTimeout(() => {
					const dv = this.$refs.tubiao2
					let myChart = this.$echarts.init(dv)
					const dataname = []
					const data = []
					this.moduleThreeData.two_child_map.values.forEach(item => {
						dataname.push(item.item)
						data.push({
							value: item.count,
							name: item.item
						})
					})
					myChart.setOption({
						title: {
							textStyle: {
								color: "#ccc",
								fontSize: 11
							},
							top: 0,
							right: 10
						},
						color: ["rgba(3,252,255,1)"],
						xAxis: {
							type: 'category',
							data: dataname,
							// data: Object.keys(tb2),
							axisLabel: {
								color: "rgba(159,218,250,1)",
								interval: 0,
								fontSize: 10
								// rotate: -30,
							},
							offset: 2,
							axisTick: false, //去除刻度标线 布尔值
							show: true,
							axisLine: {
								lineStyle: {
									color: 'rgba(255,255,255,0.68)',
									width: 2
								}
							}
						},
						axisLine: {
							show: false,
							lineStyle: { //lineStyle里面写y轴那一条线的样式
								color: 'rgba(255,255,255,0.68)',
								width: 2,
							},
						},
						yAxis: {
							type: 'value',
							axisLabel: {
								color: "rgba(159,218,250,1)",
								// 展示过程中出现问题添加
								interval: 0
							},
							// max: 40,
							//设置轴线的属性
							axisLine: {
								lineStyle: {
									color: 'rgba(255,255,255,0.68)',
									width: 3
								}
							},
							"axisTick": { //y轴刻度线
								"show": false
							},
							"splitLine": { //网格线
								"show": false
							}
						},
						// 设置缩放比例
						grid: {
							top: '10%',
							right: '4%',
							left: '8%',
							bottom: '28%'
						},
						series: [{
							data: data,
							// data: Object.values(tb2), 
							type: 'bar',
							barWidth: '26px',
							itemStyle: {
								normal: {
									label: { //柱状图的文字显示
										show: true, // 设置显示
										position: "top", //位置
										textStyle: { //数值样式
											color: '#ccc',
											fontSize: 11
										}
									},
									color: new this.$echarts.graphic.LinearGradient(
										0, 0, 0, 1,
										[{
												offset: 0,
												color: 'rgba(3,252,255,1)'
											}, //柱图渐变色                          
											{
												offset: 1,
												color: 'rgba(0,204,255,0)'
											}, //柱图渐变色
										]
									),
								},
						
								emphasis: {
									color: new this.$echarts.graphic.LinearGradient(
										0, 0, 0, 1,
										[{
												offset: 0,
												color: '#06B5D7'
											}, //柱图高亮渐变色
											{
												offset: 1,
												color: '#71C8B1'
											} //柱图高亮渐变色
										]
									)
								}
							},
						}]
					})
				}, 500)
			},
			drawLineThree() {
				setTimeout(() => {
					const dv = this.$refs.tubiao3
					let myChart = this.$echarts.init(dv)
					const dataname = []
					const data = []
					let add = 0
					this.moduleThreeData.three_child_map.industry_area_values.forEach(item => {
						dataname.push(item.item)
						data.push({
							value: item.count,
							name: item.item
						})
						add += item.count
					})
					myChart.setOption({
						legend: {
							orient: 'horizontal',
							bottom: '15%',
							// data: ['机器人和智能制造', '生物技术和大健康', '其他', '科技与文化融合产业', '新能源智能汽车', '新一代信息技术'],
							data: dataname,
							textStyle: {
								color: "#fff"
							},
							itemWidth: 13,
							itemHeight: 13,
							icon: 'circle'
						},
						series: [{
							type: 'pie',
							selectedMode: 'single',
							// radius: 60,  //图的大小
							radius: ['25%', '53%'],
							center: ['50%', '38%'], //图的位置，距离左跟上的位置
							// color:[,'#1B57E3','#EE584F', '#4CAFF5', '#B843EF'],
							color: ['#0EE19E', '#4CAFF5', '#EE584F', '#FFE900', '#1B57E3', '#F59B30'],
							label: {
								normal: {
									padding: [0, -20],
									formatter: '{c}',
									textStyle: {
										color: '#fff',
										fontWeight: 'bold',
										fontSize: 14
									}
								},
							},
							labelLine: {
								normal: {
									show: false,
								}
							},
							data: data
						}]
					})
				}, 500) 
			},
			drawLineFour() {
				setTimeout(() => {
					const dv = this.$refs.tubiao4
					let myChart = this.$echarts.init(dv)
					const dataname = []
					const data = []
					this.moduleThreeData.four_child_map.industry_values.forEach(item => {
						dataname.push(item.item)
						data.push({
							value: item.count,
							name: item.item
						})
					})
					
					myChart.setOption({
						legend: {
							orient: 'horizontal',
							bottom: '15%',
							data: dataname,
							textStyle: {
								color: "#fff"
							},
							itemWidth: 13,
							itemHeight: 13,
							icon: 'circle'
						},
						series: [{
							type: 'pie',
							selectedMode: 'single',
							// radius: 97,  //图的大小
							radius: ['25%', '53%'],
							center: ['50%', '35%'], //图的位置，距离左跟上的位置
							color: ['#0EE19E', '#4CAFF5', '#EE584F', '#FFE900', '#1B57E3', '#F59B30'],
							roseType: 'radius',
							label: {
								normal: {
									// position:'inner',
									padding: [0, -20],
									formatter: '{c}',
									textStyle: {
										color: '#fff',
										fontWeight: 'bold',
										fontSize: 14
									}
								}
							},
							labelLine: {
								normal: {
									show: false
								}
							},
							data: data
						}]
					})
				}, 500)
			}
			
		}
	}
</script>

<style>
	@import url("../assets/css.css");
</style>
